import React from 'react';
import { styled } from '@mui/material/styles';
import { useHistory, useLocation } from 'react-router-dom';
import { Dialog } from '@mui/material';

import { useFetchText } from '@lialo/common/lib/hooks/useFetchText';

import BackButton from './BackButton';
import { AppBar } from '@lialo/pwa-ui/lib/PageComponents/AppBar';
import { ScrollablePageContent } from '@lialo/pwa-ui/lib/PageComponents/Page';

const PREFIX = 'PageDialog';

const classes = {
  appBar: `${PREFIX}-appBar`,
  leftBtn: `${PREFIX}-leftBtn`,
  title: `${PREFIX}-title`,
  textContainer: `${PREFIX}-textContainer`,
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`& .${classes.appBar}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },

  [`& .${classes.leftBtn}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.title}`]: {
    flexGrow: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  [`& .${classes.textContainer}`]: {
    padding: theme.spacing(2),
  },
}));

interface Props {
  title: string | null
  children: React.ReactNode;
  open: boolean;
  onBack: () => void;
}

export const PageDialog = ({ title, open, children, onBack }: Props) => {
  return (
    <StyledDialog open={open} fullScreen={true}>
      <AppBar title={title} leftElement={<BackButton onClick={onBack} />} />
      <ScrollablePageContent className={classes.textContainer}>
        {children}
      </ScrollablePageContent>
    </StyledDialog>
  );
};

